"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var getCarbonImpactDateInterval = function getCarbonImpactDateInterval(momentInstance, date) {
  var today = momentInstance(date);
  var startOfWeekCurrentPeriod = today.clone().startOf('week');
  var lastWeekCurrentDateEquivalent = today.clone().subtract(7, 'days');
  var startOfWeekLastWeek = lastWeekCurrentDateEquivalent.clone().startOf('week');
  return {
    currentPeriod: {
      start: startOfWeekCurrentPeriod.toDate(),
      end: today.toDate()
    },
    lastPeriod: {
      start: startOfWeekLastWeek.toDate(),
      end: lastWeekCurrentDateEquivalent.toDate()
    }
  };
};

var _default = getCarbonImpactDateInterval;
exports["default"] = _default;
//# sourceMappingURL=carbonImpactDateInterval.js.map